"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default() {
  return {
    // there's no EDU impression event, so don't log impressions
    logImpression: false,
    text: 'Check Rate'
  };
};
exports.default = _default;